import { useMutation } from '@tanstack/react-query';
import { signup } from './api';


export const useSignupMutation = () => useMutation({ mutationFn: signup });

